import { ChevronRight } from 'lucide-react';
import gridArtwork from '@/assets/sales-recommendations/grid.svg';
import promoteArtwork from '@/assets/sales-recommendations/promote.png';
import excludeArtwork from '@/assets/sales-recommendations/exclude.png';
import type { RecommendationConfig, SelectionKind } from '@/types';

const CATEGORIES = [
  { key: 'productIds', label: 'Products' },
  { key: 'tags', label: 'Tags' },
  { key: 'collectionIds', label: 'Collections' },
] as const;

export function RecommendationOverview({ config, onOpen }: { config: RecommendationConfig; onOpen(kind: SelectionKind, mode: 'promoted' | 'excluded'): void }) {
  return <div className='flex w-full max-w-[640px] flex-col gap-4 px-5 py-6'>
    {(['promoted', 'excluded'] as const).map((mode) => {
      const title = mode === 'promoted' ? 'Promote' : 'Exclude';
      return <section key={mode} className='overflow-hidden rounded-2xl border border-gray-500 bg-white'>
        <div className='relative flex min-h-[111px] items-center justify-between gap-6 overflow-hidden border-b border-gray-500 px-3 py-3'>
          <img src={gridArtwork} alt='' aria-hidden className='pointer-events-none absolute top-0 left-0 max-w-none' />
          <div className='relative min-w-0 max-w-[418px] flex-1'>
            <h2 className='text-base font-medium leading-6 text-ink-strong'>{title}</h2>
            <p className='mt-2 text-xs leading-4 text-gray-800'>{mode === 'promoted'
              ? 'Choose what goes first when products fit a shopper equally well, like campaign items or seasonal pushes. Nothing is forced in.'
              : 'Select the products that you would like to exclude from being recommended by the sales agent.'}</p>
          </div>
          <img src={mode === 'promoted' ? promoteArtwork : excludeArtwork} alt='' className='relative h-[81px] w-[104px] shrink-0 object-contain' width={104} height={81} />
        </div>
        <div className='px-4'>
          {CATEGORIES.map((category) => <button key={category.key} type='button' aria-label={`${title} ${category.label.toLowerCase()}`} onClick={() => onOpen(category.key, mode)} className='flex h-[50px] w-full cursor-pointer items-center gap-3 border-b border-gray-500 text-left last:border-b-0 hover:bg-gray-50 focus-visible:outline-2 focus-visible:outline-indigo-500'>
            <span className='flex-1 text-sm text-ink'>{category.label}</span>
            <span className='text-xs text-gray-800'>{config[mode][category.key].length} {config[mode][category.key].length === 1 ? category.label.toLowerCase().slice(0, -1) : category.label.toLowerCase()}</span>
            <ChevronRight className='size-4 text-gray-800' strokeWidth={1.5} />
          </button>)}
        </div>
      </section>;
    })}
  </div>;
}
